export function getTextColor(backgroundColor?: string) {
  if (!backgroundColor) return;
  // Convert the HEX background color to RGB
  const hexToRgb = backgroundColor.replace('#', '');
  const r = parseInt(hexToRgb.substring(0, 2), 16);
  const g = parseInt(hexToRgb.substring(2, 4), 16);
  const b = parseInt(hexToRgb.substring(4, 6), 16);

  // Calculate luminance using the HSP color model
  const luminance = Math.sqrt(0.299 * r ** 2 + 0.587 * g ** 2 + 0.114 * b ** 2);

  // If luminance is above 128, return black text, otherwise white
  return luminance > 152 ? '#07162F' : '#FFFFFF';
}
